import React from "react";
import { Alert } from "react-bootstrap";

const ComponentError = ({ children }) => {
  return <Alert variant="danger">{children}</Alert>;
};

export default ComponentError;
